<template>
  <footer>
    <div class="container" id="sobregrupoparque">
      <p>
        O Grupo Parque das Flores surgiu em 1973 e atua há 50 anos no segmento
        do luto em Alagoas. Oferecendo respeito, dignidade, conforto e amparo às
        famílias do nosso estado.
      </p>
      <hr />
      <h1>Conheça as nossas empresas:</h1>
      <!-- <img src="../../assets/images/Elementos/logosempresas.png" alt="" /> -->
      
      <v-container class="logos-container py-0">
        <!-- Primeira linha: 4 imagens -->
        <v-row justify="center" dense class="logos-row mb-4">
          <v-col
            cols="12"
            sm="4"
            md="2"
            v-for="(empresa, i) in empresas.slice(0, 4)"
            :key="'linha1-' + i"
            class="pa-0 d-flex justify-center align-center mb-2"
          >
            <v-img :src="empresa" contain class="mx-1 logo-img"></v-img>
          </v-col>
        </v-row>

        <!-- Segunda linha: 3 imagens centralizadas -->
        <v-row justify="center" dense class="logos-row mt-n4">
          <v-col
            cols="12"
            sm="4"
            md="2"
            v-for="(empresa, i) in empresasLinha2.slice(0, 3)"
            :key="'linha2-' + i"
            class="pa-0 d-flex justify-center align-center"
          >
            <v-img :src="empresa" contain class="mx-1 logo-img"></v-img>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <div class="subcontainer">
      <div class="links">
        <div class="links-group">
          <a href="" class="link">Brasil</a>
          <a
            href="/assets/politicas/POL0006R02_PP.pdf"
            class="link"
            target="_blank"
            >Política de Privacidade</a
          >
          <a href="/termo-uso" class="link">Termos de Uso</a>
        </div>
        <div class="copyright">
          <span
            >&copy; 2025 Grupo Parque das Flores. Todos os direitos
            reservados.</span
          >
          <span
            >R. Des. Barreto Cardoso, 317 - Gruta de Lourdes, Maceió - AL,
            57052-850</span
          >
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import logoAflordocafe from "@/assets/images/logos_footer/aflordocafe.png";
import logoMemorial from "@/assets/images/logos_footer/memorial.png";
import logoParqueDasFlores from "@/assets/images/logos_footer/parquedasflores.png";
import logoPrevida from "@/assets/images/logos_footer/previda.png";
import logoCemiterioPrevida from "@/assets/images/logos_footer/cemiterioprevida.png";
import logoParqueDoAgreste from "@/assets/images/logos_footer/parquedoagreste.png";
import logoMemorialFlores from "@/assets/images/logos_footer/memorialflores.png";

export default {
  data() {
    return {
      empresas: [
        logoParqueDasFlores,
        logoMemorial,
        logoPrevida,
        logoAflordocafe,
      ],
      empresasLinha2: [
        logoCemiterioPrevida,
        logoParqueDoAgreste,
        logoMemorialFlores,
      ],
    };
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Sora:wght@100..800&display=swap");
*,
*::before,
*::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-family: "Sora", sans-serif;
}
footer .container {
  background-color: #343f53;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 2rem;
}

footer .subcontainer {
  background-color: #ffffff;
}

p {
  color: #ffffff;
  font-size: 25px;
  font-weight: 100;
  text-align: center;
  padding: 0 20rem;
  margin-top: 1.5rem;
}

h1 {
  color: #ffffff;
  font-size: 49px;
  font-weight: 600;
  font-family: "Sora", sans-serif;
}

hr {
  min-width: 25rem;
}

a {
  text-decoration: none;
  color: #343f53;
  font-size: 18px;
  font-weight: 500;
  font-family: "Sora", sans-serif;
}

.links {
  display: flex;
  flex-direction: column;
  padding: 1.5rem 3rem;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
}

.links-group {
  display: flex;
  justify-content: center;
  gap: 2rem;
  margin-bottom: 1.5rem;
}

.link {
  display: flex;
  align-items: center;
  transition: color 0.3s ease;
}

.link:hover {
  color: #5a6b85;
}

.copyright {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  font-size: 14px;
  color: #666;
  gap: 0.5rem;
}
@media (min-width: 768px) and (max-width: 1024px) {
  p {
    padding: 0 2rem;
    font-size: 20px;
  }
  h1 {
    font-size: 30px;
  }
  img {
    width: 80%;
  }
  .links-group {
    flex-wrap: wrap;
  }
  .container h1 {
    padding: 1rem;
  }
}

@media (max-width: 767px) {
  p {
    padding: 0 1.5rem;
    font-size: 18px;
  }
  h1 {
    font-size: 26px;
  }
  img {
    width: 90%;
  }
  .links-group {
    flex-direction: column;
    align-items: center;
    gap: 1rem;
  }
  .copyright {
    font-size: 12px;
  }
  .container h1 {
    padding: 1rem;
    text-align: center;
  }
}
.logos-container {
  padding: 0;
}

.logos-row {
  margin: 0;
  gap: 0;
}

.logo-img {
  max-width: 180px;
  max-height: 180px;
  min-height: 80px;
  transition: transform 0.2s;
}

.logo-img:hover {
  transform: scale(1.05);
}

@media (max-width: 767px) {
  .logos-row {
    margin-top: -8px !important;
  }
  
  .logo-img {
    max-width: 120px;
    max-height: 120px;
    min-height: 60px;
  }
}
</style>
